import { Show, SimpleShowLayout, TextField } from "react-admin";
import { ShowHeader } from "../../utils/header";
import { ImageListField } from "../image/components/Field";

export function SelectionShow(): JSX.Element {
    return (
        <Show title={<ShowHeader field="name" />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="title" />
                <TextField source="description" />
                <ImageListField targetType="selection" />
            </SimpleShowLayout>
        </Show>
    );
}
